import { render, staticRenderFns } from "./LeaderboardSubHeader.vue?vue&type=template&id=4b9dff08&scoped=true&"
import script from "./LeaderboardSubHeader.vue?vue&type=script&lang=js&"
export * from "./LeaderboardSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardSubHeader.vue?vue&type=style&index=0&id=4b9dff08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9dff08",
  null
  
)

export default component.exports